import { Accepts, Types } from "@citychallenge/common";
import { TransTokens } from "../../../i18n";
import { Inlet } from "../../reactive";
import { defineElement } from "../define-element";

export class DemographicProps {
  @Inlet(Accepts.Image) public headerImage?: Types["Image"];
  @Inlet(Accepts.MarkdownText) public text?: Types["MarkdownText"];
  @Inlet(Accepts.Boolean) public gender?: Types["Boolean"];
  @Inlet(Accepts.Boolean) public age?: Types["Boolean"];
}

export const DemographicDefinition = defineElement(
  "demographic",
  DemographicProps,
  {
    versionRequired: "0.9.0",
  }
);

export const demographicTokens = TransTokens.create({
  genderQuestion: "What is your gender?",
  male: "Male",
  female: "Female",
  nonBinary: "Non-binary",
  age: "Age",
  ageQuestion: "What is your age?",
});
